import React from 'react'

interface LiveRegionProps {
  messages: string[]
  priority?: 'polite' | 'assertive'
  className?: string
}

export const LiveRegion: React.FC<LiveRegionProps> = ({ 
  messages, 
  priority = 'polite',
  className = 'sr-only'
}) => {
  return (
    <div
      aria-live={priority}
      aria-atomic="true"
      className={className}
      role="status"
    >
      {messages.map((message, index) => (
        <div key={index}>
          {message}
        </div>
      ))}
    </div>
  )
}